var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "section",
        { staticClass: "main-banner-section" },
        [
          _c("content-creator", {
            attrs: {
              settings: _vm.getBlobContents("main-banner"),
              permissions: _vm.contentCreatorPermissions,
              "is-visible": _vm.editContentCreator,
              filestore: _vm.websitefilestore,
              name: "main-banner",
              "allowed-widgets":
                "carousel,content-list,content-grid,vimeo-video",
            },
            on: { updateBlob: (data) => _vm.saveBlob("main-banner", data) },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "cta-section upper-cta-section" },
        [
          _c("content-creator", {
            staticClass: "home-intro-content",
            attrs: {
              settings: _vm.getBlobContents("content-blob-1-above"),
              permissions: _vm.contentCreatorPermissions,
              "is-visible": _vm.editContentCreator,
              filestore: _vm.websitefilestore,
              name: "content-blob-1-above",
              "allowed-widgets":
                "advanced-wysiwyg-editor, wysiwyg-editor, grid, links, vimeo-video",
            },
            on: {
              updateBlob: (data) => _vm.saveBlob("content-blob-1-above", data),
            },
          }),
          _vm._v(" "),
          _c("content-creator", {
            attrs: {
              settings: _vm.getBlobContents("content-blob-1"),
              permissions: _vm.contentCreatorPermissions,
              "is-visible": _vm.editContentCreator,
              filestore: _vm.websitefilestore,
              name: "content-blob-1",
              "allowed-widgets": "*",
            },
            on: { updateBlob: (data) => _vm.saveBlob("content-blob-1", data) },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "cta-section middle-cta-section" },
        [
          _c("content-creator", {
            staticClass: "home-intro-content",
            attrs: {
              settings: _vm.getBlobContents("home-product-carousel-header"),
              permissions: _vm.contentCreatorPermissions,
              "is-visible": _vm.editContentCreator,
              filestore: _vm.websitefilestore,
              name: "home-product-carousel-header",
              "allowed-widgets":
                "advanced-wysiwyg-editor, wysiwyg-editor, grid, link-list, carousel, content-grid, content-list, vimeo-video",
            },
            on: {
              updateBlob: (data) =>
                _vm.saveBlob("home-product-carousel-header", data),
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "cta-section lower-cta-section" },
        [
          _c("content-creator", {
            attrs: {
              settings: _vm.getBlobContents("latest-news"),
              permissions: _vm.contentCreatorPermissions,
              "is-visible": _vm.editContentCreator,
              filestore: _vm.websitefilestore,
              name: "latest-news",
            },
            on: { updateBlob: (data) => _vm.saveBlob("latest-news", data) },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.extraContentCreators, function (_, index) {
        return _c(
          "section",
          { key: index, class: `cta-section cta-section-${index}` },
          [
            _c("content-creator", {
              attrs: {
                settings: _vm.getBlobContents(`home-page-extra-${index}`),
                permissions: _vm.contentCreatorPermissions,
                "is-visible": _vm.editContentCreator,
                filestore: _vm.websitefilestore,
                name: `home-page-extra-${index}`,
              },
              on: {
                updateBlob: (data) =>
                  _vm.saveBlob(`home-page-extra-${index}`, data),
              },
            }),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }